import { CourseStateType } from 'enum'
import { ICourseModel } from 'models/course.model'
import { CreateNewCourseForm } from './types'
import { ShowDates } from './constants'

const profileIds = (profiles: { value: number }[] | undefined) =>
  (profiles ?? [])
    .map((p) => p.value)
    .sort((a, b) => a - b)
    .join(',')

export function courseFormHasContentChanges(
  values: CreateNewCourseForm,
  initialValues: ICourseModel | undefined,
  description: string
): boolean {
  if (!initialValues?.id) {
    return false
  }

  if ((values.name ?? '') !== (initialValues.name ?? '')) return true
  if (description !== (initialValues.description ?? '')) return true
  if (Boolean(values.normative) !== Boolean(initialValues.normative))
    return true
  if (String(values.hours ?? '') !== String(initialValues.hours ?? ''))
    return true
  if (
    Boolean(values.canGenerateCertificate) !==
    Boolean(initialValues.canGenerateCertificate)
  )
    return true
  if (Boolean(values.canRestart) !== Boolean(initialValues.canRestart))
    return true
  if (values.courseType !== initialValues.courseType) return true

  const initialShowDates =
    initialValues.startDate || initialValues.untilDate
      ? ShowDates.active
      : ShowDates.inactive
  if (values.showDates !== initialShowDates) return true

  const startChanged =
    (values.startDate?.getTime() ?? null) !==
    (initialValues.startDate
      ? new Date(initialValues.startDate).getTime()
      : null)
  const untilChanged =
    (values.untilDate?.getTime() ?? null) !==
    (initialValues.untilDate
      ? new Date(initialValues.untilDate).getTime()
      : null)
  if (startChanged || untilChanged) return true

  if (
    profileIds(values.requiredProfiles as { value: number }[]) !==
    profileIds(
      initialValues.requiredProfiles?.map((p) => ({ value: Number(p.id) }))
    )
  ) {
    return true
  }
  if (
    profileIds(values.optionalProfiles as { value: number }[]) !==
    profileIds(
      initialValues.optionalProfiles?.map((p) => ({ value: Number(p.id) }))
    )
  ) {
    return true
  }

  return false
}
